export default __webpack_public_path__ + "static/media/unknown-carrier.77e7fec2.svg";